<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 q-pa-sm">
        <q-card q-card flat bordered>
          <q-card-section>
            <h6 class="q-my-none q-mt-xs">
              {{ currentEvent.event_name }}
            </h6>
          </q-card-section>
          <q-separator />
          <q-card-section
            v-if="
              $route.path.includes('waves') ||
                ($moment() < $moment(competition.entriesCloseDate) &&
                  currentEvent.currentStep == 0) ||
                currentEvent.entriesOpenOverride ||
                ['Admin', 'Sport Manager'].includes(currentUserData.role)
            "
          >
            <div class="row">
              <div class="col-12">
                <h6 class="q-my-none q-mt-xs">Team Details</h6>
              </div>
              <div class="col-12 col-md-6 q-px-xs" v-if="fromWaves">
                <assignAssociation
                  :id="association_id"
                  :customData="competitionAssociations"
                  @changed="val => (association_id = val)"
                  :multiple="
                    [
                      'Admin',
                      'Waves Manager',
                      'Sport Manager',
                      'Official'
                    ].includes(currentUserData.role) && fromWaves
                  "
                />
              </div>
              <div class="col-12 col-md-6 q-pa-xs" v-if="fromWaves">
                <q-btn
                  class="full-width bg-primary text-white"
                  :label="
                    useNFCScanner
                      ? 'Manual Member Selection'
                      : 'Use NFC Scanner'
                  "
                  @click="useNFCScanner = !useNFCScanner"
                >
                </q-btn>
              </div>

              <div v-if="!fromWaves || association_id" class="col q-px-xs">
                <q-input
                  v-model="formData.team_name"
                  label="Team Name"
                  v-bind="siteCFG.fields.general"
                  :readonly="currentEvent.teamNamingFormat > 2"
                  :prefix="
                    currentEvent.teamNamingFormat == 2
                      ? association.association_name
                      : ''
                  "
                >
                </q-input>
              </div>
              <div v-if="fromWaves" class="col-12 q-pa-xs">
                <autocomplete
                  label="Event"
                  :items="events.filter(e => e.id == id || e.parent_id == id)"
                  :itemsLoading="eventsLoading"
                  option_label="event_name"
                  option_value="id"
                  :id="parseInt(eventIdOverride)"
                  @changed="
                    val => {
                      eventIdOverride = val;
                    }
                  "
                  clearable
                />
              </div>
            </div>
            <div
              class="row"
              v-if="(!fromWaves || association_id) && !useNFCScanner"
            >
              <div class="col-12">
                <h6 class="q-my-none q-mt-md">Team Athletes</h6>
              </div>
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-12 font-weight-bold"><b>Required</b></div>
                  <div
                    class="col-12 q-pa-xs"
                    v-for="(playerLabel, index) in playerLabels.filter(
                      val => val.required == 1
                    )"
                    :key="`athlete_${index}`"
                  >
                    <assignMember
                      :id="athletes[index]"
                      :label="
                        `${playerLabel.name}${
                          playerLabel.required == 1 ? ' *' : ''
                        }`
                      "
                      :readonly="formData.id ? true : false"
                      :filterToEvent="data"
                      :filterToPlayerLabel="playerLabel"
                      :excludeIDList="excludedAthletes"
                      @changed="
                        val => updateMember(val, index, playerLabel.required)
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-12 font-weight-bold"><b>Reserves</b></div>
                  <div
                    class="col-12 q-pa-xs"
                    v-for="(playerLabel, index) in playerLabels.filter(
                      val => val.required != 1
                    )"
                    :key="`athlete_${index}`"
                  >
                    <assignMember
                      :id="athletes[index + totalRequiredMembers]"
                      :label="
                        `${playerLabel.name}${
                          playerLabel.required == 1 ? ' *' : ''
                        }`
                      "
                      :readonly="formData.id ? true : false"
                      :filterToEvent="data"
                      :filterToPlayerLabel="playerLabel"
                      :excludeIDList="excludedAthletes"
                      @changed="
                        val =>
                          updateMember(
                            val,
                            index + totalRequiredMembers,
                            playerLabel.required
                          )
                      "
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="
                  (currentEvent.minCombinedAge > combinedAge ||
                    currentEvent.maxCombinedAge < combinedAge) &&
                    (currentEvent.maxCombinedAge ||
                      currentEvent.minCombinedAge) &&
                    athletes.length >=
                      playerLabels.filter(val => val.required == 1).length
                "
                class="col-12 q-pa-md"
              >
                <q-card style="border: 2px solid #e21f27" class="q-pa-md" flat>
                  Can’t enter team into current event due to combined age, your
                  current combined age is {{ combinedAge }}
                </q-card>
              </div>

              <div class="col-12">
                <q-btn
                  class="float-right"
                  color="primary"
                  no-caps
                  :loading="enteringTeamLoading"
                  @click="submitTeam()"
                  :disable="
                    requiredEntryCount < totalRequiredMembers ||
                      totalRequiredMembers == 0 ||
                      ((currentEvent.minCombinedAge > combinedAge ||
                        currentEvent.maxCombinedAge < combinedAge) &&
                        (currentEvent.maxCombinedAge ||
                          currentEvent.minCombinedAge) &&
                        athletes.length >=
                          playerLabels.filter(val => val.required == 1).length)
                  "
                >
                  Submit Team
                </q-btn>
              </div>
            </div>
            <div class="row" v-if="useNFCScanner">
              <div class="col-12">
                <h6 class="q-my-none q-mt-md">Team Athletes</h6>
              </div>
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-12 font-weight-bold"><b>Required</b></div>
                  <div
                    class="col-12 q-pa-xs"
                    v-for="(playerLabel, index) in playerLabels.filter(
                      val => val.required == 1
                    )"
                    :key="`athlete_${index}`"
                  >
                    {{
                      `${playerLabel.name}${
                        playerLabel.required == 1 ? " *" : ""
                      }`
                    }}
                    <div v-if="membersKeyed[athletes[index]]">
                      {{ membersKeyed[athletes[index]].firstName }}
                      {{ membersKeyed[athletes[index]].lastName }} -
                      {{ membersKeyed[athletes[index]].crm_id }}
                    </div>
                    <q-btn
                      class="bg-primary text-white full-width"
                      :class="{
                        'bg-primary': !membersKeyed[athletes[index]],
                        'bg-positive': membersKeyed[athletes[index]]
                      }"
                      :label="
                        membersKeyed[athletes[index]]
                          ? 'Change Athlete'
                          : 'Assign Athlete'
                      "
                      @click="
                        scanAthlete(
                          athletes[index],
                          data,
                          playerLabel,
                          index,
                          playerLabel.required
                        )
                      "
                    ></q-btn>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-12 font-weight-bold"><b>Reserves</b></div>
                  <div
                    class="col-12 q-pa-xs"
                    v-for="(playerLabel, index) in playerLabels.filter(
                      val => val.required != 1
                    )"
                    :key="`athlete_${index}`"
                  >
                    {{
                      `${playerLabel.name}${
                        playerLabel.required == 1 ? " *" : ""
                      }`
                    }}
                    <div
                      v-if="
                        membersKeyed[athletes[index + totalRequiredMembers]]
                      "
                    >
                      {{
                        membersKeyed[athletes[index + totalRequiredMembers]]
                          .firstName
                      }}
                      {{
                        membersKeyed[athletes[index + totalRequiredMembers]]
                          .lastName
                      }}
                      -
                      {{
                        membersKeyed[athletes[index + totalRequiredMembers]]
                          .crm_id
                      }}
                    </div>
                    <q-btn
                      class="text-white full-width"
                      :class="{
                        'bg-primary': !membersKeyed[
                          athletes[index + totalRequiredMembers]
                        ],
                        'bg-positive':
                          membersKeyed[athletes[index + totalRequiredMembers]]
                      }"
                      :label="
                        membersKeyed[athletes[index + totalRequiredMembers]]
                          ? 'Change Athlete'
                          : 'Assign Athlete'
                      "
                      @click="
                        scanAthlete(
                          athletes[index + totalRequiredMembers],
                          data,
                          playerLabel,
                          index + totalRequiredMembers,
                          playerLabel.required
                        )
                      "
                    ></q-btn>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  (currentEvent.minCombinedAge > combinedAge ||
                    currentEvent.maxCombinedAge < combinedAge) &&
                    (currentEvent.maxCombinedAge ||
                      currentEvent.minCombinedAge) &&
                    athletes.length >=
                      playerLabels.filter(val => val.required == 1).length
                "
                class="col-12 q-pa-md"
              >
                <q-card style="border: 2px solid #e21f27" class="q-pa-md" flat>
                  Can’t enter team into current event due to combined age, your
                  current combined age is {{ combinedAge }}
                </q-card>
              </div>

              <div class="col-12">
                <q-btn
                  class="float-right"
                  color="primary"
                  no-caps
                  :loading="enteringTeamLoading"
                  @click="submitTeam()"
                  :disable="
                    requiredEntryCount < totalRequiredMembers ||
                      totalRequiredMembers == 0 ||
                      ((currentEvent.minCombinedAge > combinedAge ||
                        currentEvent.maxCombinedAge < combinedAge) &&
                        (currentEvent.maxCombinedAge ||
                          currentEvent.minCombinedAge) &&
                        athletes.length >=
                          playerLabels.filter(val => val.required == 1).length)
                  "
                >
                  Submit Team
                </q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div class="row" v-if="!fromWaves || association_id">
      <div
        v-for="(team, index) in teams"
        :key="`team_${index}`"
        class="col-12 col-md-6 col-lg-4 q-pa-sm"
      >
        <teamManagementCard
          :id="id"
          :team="team"
          :selectTeam="!!round_id"
          :fromWaves="fromWaves"
          :selectedAssociation_id="
            Array.isArray(association_id)
              ? association_id.length == 1
                ? association_id[0]
                : 'Composite'
              : association_id
          "
          @selectTeam="submitTeam"
          @unscratchTeam="unscratchTeam"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignMember from "@/components/users/assignMember.vue";
import teamManagementCard from "@/components/competitions/teamManagementCard.vue";
import assignAssociation from "@/components/associations/assignAssociation.vue";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
import moment from "moment";
import { NFCScan, NFCWrite } from "@/plugins/NFC";
import { checkMemberMeetsAwardCriteria } from "@/plugins/awardChecker";

export default {
  components: {
    assignMember,
    teamManagementCard,
    assignAssociation,
    autocomplete
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "events/current",
      dataLoading: "events/currentLoading",
      competition: "competitions/current",
      members: "associations/members",
      membersKeyed: "associations/membersKeyed",
      membersCurrentEvents: "associations/membersEnteredIndividualEvents",
      teams: "eventsEntries/teamList",
      teamsLoading: "eventsEntries/teamListLoading",
      association: "associations/current",
      competitionAssociations: "competitions/associationsList",
      events: "events/listForWaves",
      eventsLoading: "events/listForWavesLoading",
      participants: "events/participantList"
      // competitionAssociationsLoading: "competitions/associationsListLoading  ",
    }),
    currentEvent() {
      let event =
        this.eventIdOverride && this.fromWaves
          ? this.events.find(x => x.id == this.eventIdOverride)
          : this.data;
      return event;
    }
  },
  props: {
    id: {
      default: null
    },
    fromWaves: {
      type: Boolean,
      default: false
    },
    competitions_id: {
      type: Number,
      default: null
    },
    round_id: {
      type: Number,
      default: null
    }
  },
  watch: {
    data: function() {
      this.init();
    },
    id: function() {
      this.init();
    },
    teams: function() {
      this.init();
    },
    association_id: function() {
      this.$store
        .dispatch("associations/loadByID", this.association_id)
        .then(() => {
          this.$store.dispatch("associations/loadMembersForAssociation", {
            id: this.association_id,
            competitions_id: this.fromWaves
              ? this.$route.params.competitions_id
              : this.competitions_id
          });

          this.init();
        });
      this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
        id: this.id,
        association_id: Array.isArray(this.association_id)
          ? this.association_id.length == 1
            ? this.association_id[0]
            : "Composite"
          : this.association_id
      });
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      team_name: ""
    },

    athletes: [],
    combinedAge: 0,
    enteringTeamLoading: false,
    requiredEntryCount: 0,
    totalRequiredMembers: 0,

    excludedAthletes: [],

    playerLabels: [],

    // For Waves
    association_id: null,

    eventIdOverride: null,

    useNFCScanner: null,
    handleReading: null
  }),
  beforeCreate() {},
  mounted() {
    if (this.fromWaves) {
      // this.$store.dispatch("events/loadAssociations", this.id);
      this.$store.dispatch(
        "competitions/loadAssociations",
        this.$route.params.competitions_id
      );
      if (this.events.length == 0) {
        this.$store.dispatch("events/loadForCompetition", this.competition.id);
      }
    }
    this.init();
    if (this.id) {
      this.$store.dispatch("events/loadByID", this.id);
      this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
        id: this.id,
        association_id: this.currentUserData.currentAssociation_id
      });
    }
  },
  methods: {
    init() {
      let team_name = "";
      switch (this.currentEvent.teamNamingFormat) {
        case 1:
          team_name = "";
          break;
        case 2:
          team_name = ``;
          break;

        case 3:
          team_name = `${this.getAssociationAbbr()}`;
          break;
        case 4:
          team_name = `${this.getAssociationAbbr()} ${this.teams.length + 1}`;
          break;

        case 5:
          team_name = `${this.getAssociationAbbr()} ${this.toLetters(
            this.teams.length + 1
          )}`;
          break;

        default:
          team_name = "";
          break;
      }

      if (
        this.currentEvent.teamNamingFormat > 3 &&
        this.teams.filter(team => team.team_name == team_name).length == 1
      ) {
        team_name = this.fillTeamNameGap();
      }

      if (this.currentEvent.playerLabels) {
        this.playerLabels = JSON.parse(this.currentEvent.playerLabels);
        this.totalRequiredMembers = 0;
        JSON.parse(this.currentEvent.playerLabels).forEach(element => {
          if (element.required == 1) {
            this.totalRequiredMembers += 1;
          }
        });
      }

      this.formData.team_name = team_name;

      this.excludedAthletes = [];
      this.teams.forEach(team => {
        team.members.forEach(member => {
          this.excludedAthletes.push(member.associationsMembers_id);
        });
      });

      this.eventIdOverride = this.id;
    },

    fillTeamNameGap() {
      let team_name = "";
      this.teams.forEach((team, index) => {
        console.log(index);
        if (team_name == "") {
          if (
            this.currentEvent.teamNamingFormat == 4 &&
            `${this.getAssociationAbbr()} ${index + 1}` != team.team_name
          ) {
            team_name = `${this.getAssociationAbbr()} ${index + 1}`;
            return team_name;
          } else if (
            this.currentEvent.teamNamingFormat == 5 &&
            `${this.getAssociationAbbr()} ${this.toLetters(index + 1)}` !=
              team.team_name
          ) {
            team_name = `${this.getAssociationAbbr()} ${this.toLetters(
              index + 1
            )}`;
            return team_name;
          }
        }
      });

      return team_name;
    },

    getAssociationAbbr() {
      return Array.isArray(this.association)
        ? this.association.length == 1
          ? this.association[0].association_abbr
          : "Composite Team"
        : this.association.association_abbr;
    },

    updateMember(id, index, requiredEntry) {
      if (!this.athletes[index] && requiredEntry == 1) {
        this.requiredEntryCount += 1;
      }
      this.athletes[index] = id;
      this.excludedAthletes.push(id);
      this.calculateCombinedAge();
      this.$forceUpdate();
    },
    calculateCombinedAge() {
      let age = 0;
      this.athletes.forEach((athlete, index) => {
        const member = this.members.find(m => m.id == athlete);
        console.log(member);
        if (member && !this.playerLabels[index].noMaxAge) {
          age += moment(this.competition.age_reference_date).diff(
            member.birthDate,
            "years",
            false
          );
        }
      });
      this.combinedAge = age;
    },
    submitTeam(val = null) {
      // this.enteringTeamLoading = true;

      let team_name = "";

      switch (this.currentEvent.teamNamingFormat) {
        case 1:
          team_name = this.formData.team_name;
          break;
        case 2:
          team_name = `${this.getAssociationAbbr()} ${this.formData.team_name}`;
          break;

        case 3:
          team_name = `${this.getAssociationAbbr()}`;
          break;
        case 4:
          team_name = `${this.getAssociationAbbr()} ${this.teams.length + 1}`;
          break;

        case 5:
          team_name = `${this.getAssociationAbbr()} ${this.toLetters(
            this.teams.length + 1
          )}`;
          break;

        default:
          team_name = this.formData.team_name;
          break;
      }

      if (
        this.currentEvent.teamNamingFormat > 3 &&
        this.teams.filter(team => team.team_name == team_name).length == 1
      ) {
        team_name = this.fillTeamNameGap();
      }

      let payload = {
        team_name: val ? val.team_name : team_name,
        athletes: this.athletes,
        events_id:
          this.eventIdOverride && this.fromWaves
            ? this.eventIdOverride
            : this.id,
        associations_id: this.association_id
          ? Array.isArray(this.association_id)
            ? this.association_id.length == 1
              ? this.association_id[0]
              : null
            : this.association_id
          : this.currentUserData.currentAssociation_id,

        competitions_id: this.competition.id,
        round_id: this.round_id,
        team_id: val ? val.id : null,
        composite:
          this.association_id &&
          Array.isArray(this.association_id) &&
          this.association_id.length > 1
            ? 1
            : 0
      };

      if (payload.team_name == "") {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "Please enter a team name for the team"
        });
        return;
      }

      if (
        this.teams.filter(
          t => t.team_name.toLowerCase() == payload.team_name.toLowerCase()
        ).length > 0
      ) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "Team name is already in use"
        });
        return;
      }

      this.$refs.form.validate().then(result => {
        if (result) {
          this.$store
            .dispatch("eventsEntries/enterTeamIntoEvent", payload)
            .then(result => {
              this.enteringTeamLoading = false;
              if (result.Result == "Success") {
                this.formData = {};
                this.requiredEntryCount = 0;

                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
                // this.$emit("close");
                this.athletes = [];
                this.init();
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response
                });
              }
              let payload = {
                id:
                  this.eventIdOverride && this.fromWaves
                    ? this.eventIdOverride
                    : this.id,
                association_id: this.association_id
                  ? Array.isArray(this.association_id)
                    ? this.association_id.length == 1
                      ? this.association_id[0]
                      : "Composite"
                    : this.association_id
                  : this.currentUserData.currentAssociation_id
              };

              this.$store.dispatch(
                "eventsEntries/loadAllTeamsForEvent",
                payload
              );

              this.$store.dispatch(
                "events/loadForCompetition",
                this.competition.id
              );

              this.$emit("newTeamEntered");
            });
        } else {
          this.enteringTeamLoading = false;
        }
      });
    },
    async unscratchTeam(val) {
      let payload = {
        value: 0,
        isTeamEvent: 1,
        id: val.id,
        round_id: this.round_id,
        events_id: this.id
      };

      try {
        let result = await this.$store.dispatch(
          "eventProgress/scratchMember",
          payload
        );
        this.$store.dispatch("eventsEntries/loadAllTeamsForEvent", {
          id: this.id,
          association_id: Array.isArray(this.association_id)
            ? this.association_id.length == 1
              ? this.association_id[0]
              : "Composite"
            : this.association_id
        });

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.data.Message
          });
          this.$emit("newTeamEntered");
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },

    toLetters(num) {
      "use strict";
      var mod = num % 26,
        pow = (num / 26) | 0,
        out = mod ? String.fromCharCode(64 + mod) : (--pow, "Z");
      return pow ? this.toLetters(pow) + out : out;
    },

    // NGC
    async handleNFCScan(message, serialNumber, extraData) {
      this.nfcScanner.removeEventListener("reading", this.handleReading);

      // ADD NFC to Member
      try {
        let response = await this.$store.dispatch(
          "associations/loadMemberViaNFC",
          {
            serialNumber: serialNumber
          }
        );

        if (response.Result) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: response.Message
          });
          return;
        }

        // Check Member Meets Event Criteria
        let member = response[0];

        let result = checkMemberMeetsAwardCriteria(
          {
            competition: this.competition,
            playerLabel: extraData.filterToPlayerLabel,
            filterToEvent: extraData.filterToEvent,
            excludeAthletesIds: extraData.excludeIDList
          },
          member
        );

        if (!result.passed) {
          result.messages.forEach(message => {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: message
            });
          });

          return;
        }

        Array.isArray(this.association_id)
          ? this.association_id.push(member.associations_id)
          : (this.association_id = [member.associations_id]);

        // make array unique
        this.association_id = [...new Set(this.association_id)];

        this.updateMember(member.id, extraData.index, extraData.required);

        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: "Member Added to Team"
        });
      } catch (error) {
        console.log(error);
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async scanAthlete(id, filterToEvent, filterToPlayerLabel, index, required) {
      try {
        this.nfcScanner.removeEventListener("reading", this.handleReading);
      } catch (error) {
        console.log(error);
      }

      let excludeIDList = [];

      this.participants.forEach(teams => {
        teams.members.forEach(team_member => {
          excludeIDList.push(team_member.associationsMembers_id);
        });
      });

      const { ndef, handleReading } = await NFCScan(this, this.handleNFCScan, {
        id: id,
        filterToEvent: filterToEvent,
        filterToPlayerLabel: filterToPlayerLabel,
        excludeIDList: excludeIDList,
        index: index,
        required: required
      });

      this.nfcScanner = ndef;
      this.handleReading = handleReading;
    }
  }
};
</script>

<style lang="scss" scoped>
.eventCard {
  min-width: 220px !important;
}
</style>
